import React from 'react';
import clsx from 'clsx';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { Icon } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

import styles from './styles.scss?modules';

const SolutionsBullets = React.memo(({ benefits }) => {
  const { header, description, content } = benefits;
  return (
    <>
      <LazyScrollMetricTracker
        scrollDtm={benefits.dtm}
        startTrackingAfterPznArrival
      />
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <img src={benefits.imageUrl} alt={benefits.imageAlt} load="lazy" />
        </div>
        <div className={styles.contentContainer}>
          <h2 className={styles.header}>{header}</h2>
          <p className={styles.description}>{description}</p>
          <div className={styles.contentItemsContainer}>
            {content.map(({ header, description, imageName }, i) => (
              <div
                key={header}
                className={clsx(styles.contentItemContainer, {
                  [styles.lastTwo]: i === 2 || i === 3
                })}
              >
                <Icon
                  className={styles.icon}
                  directory="dls"
                  imageName={imageName}
                />
                <div className={styles.contentItemTextContainer}>
                  <h3>{header}</h3>
                  <Sanitizer
                    className={styles.description}
                    safelySetInnerHTML={description}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
});

export default SolutionsBullets;
